<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <ValidationObserver ref="form">
        <b-card class="w-100 h-100">
          <b-row>
            <b-col cols="12" md="6" class="mt-3">
              <ValidationProvider
                rules="required"
                name="ชื่อกลุ่มชุดอนุกรรมการ"
                v-slot="{ errors }"
              >
                <b-form-group
                  class="required"
                  label="ชื่อกลุ่มชุดอนุกรรมการ"
                  label-for="officer"
                >
                  <template v-slot:label>
                    ชื่อกลุ่มชุดอนุกรรมการ <span class="text-danger">*</span>
                  </template>
                  <vue-select
                    label="name"
                    value="id"
                    :required="true"
                    v-model="groupSelect"
                    :options="groupOptions"
                    @input="selectOnInput"
                    class=""
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>

            <b-col cols="12" md="6" class="md mt-3">
              <ValidationProvider
                name="ข้อมูลในระบบ portal"
                v-slot="{ errors }"
              >
                <b-form-group
                  class=""
                  label="ข้อมูลในระบบ portal"
                  label-for="officer"
                >
                  <template v-slot:label>
                    ข้อมูลในระบบ portal
                    (จะทำให้สามารถเข้ามาอนุมัติจดหมายเชิญในฐานะเลขาได้)
                  </template>
                  <vue-select
                    label="name"
                    value="id"
                    v-model="officerSelect"
                    :options="officerOptions"
                    @input="selectOnInputOfficer"
                    class=""
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>

            <b-col cols="12" md="3">
              <ValidationProvider
                name="รหัสบัตรประจำตัวประชาชน"
                v-slot="{ errors }"
              >
                <b-form-group
                  label="รหัสบัตรประจำตัวประชาชน"
                  label-for="identityId"
                >
                  <b-form-input
                    id="identityId"
                    v-model="model.identityId"
                    placeholder="กรุณากรอก รหัสบัตรประจำตัวประชาชน"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="3">
              <ValidationProvider
                rules="required"
                name="คำนำหน้า"
                v-slot="{ errors }"
              >
                <b-form-group label="คำนำหน้า" label-for="prefix">
                  <template v-slot:label>
                    คำนำหน้า <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="prefix"
                    v-model="model.prefix"
                    placeholder="กรุณากรอก คำนำหน้า"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="3">
              <ValidationProvider
                rules="required"
                name="ชื่อ"
                v-slot="{ errors }"
              >
                <b-form-group label="ชื่อ" label-for="firstname">
                  <template v-slot:label>
                    ชื่อ <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="firstname"
                    v-model="model.firstname"
                    placeholder="กรุณากรอก ชื่อ"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="3">
              <ValidationProvider
                rules="required"
                name="นามสกุล"
                v-slot="{ errors }"
              >
                <b-form-group label="นามสกุล" label-for="lastname">
                  <template v-slot:label>
                    นามสกุล <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="lastname"
                    v-model="model.lastname"
                    placeholder="กรุณากรอก นามสกุล"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="6">
              <ValidationProvider name="ตำแหน่งงาน" v-slot="{ errors }">
                <b-form-group label="ตำแหน่งงาน" label-for="position">
                  <b-form-input
                    id="position"
                    v-model="model.position"
                    placeholder="กรุณากรอก ตำแหน่งงาน"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="6">
              <ValidationProvider
                rules="required"
                name="ตำแหน่งในอนุกรรมการ"
                v-slot="{ errors }"
              >
                <b-form-group
                  class=""
                  label="ตำแหน่งในอนุกรรมการ"
                  label-for="officer"
                >
                  <template v-slot:label>
                    ตำแหน่งในอนุกรรมการ <span class="text-danger">*</span>
                  </template>
                  <vue-select
                    label="description"
                    value="masterId"
                    :required="true"
                    v-model="directorPositionSelect"
                    :options="directorPositionOptions"
                    @input="selectOnInput"
                    class=""
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>

            <b-col cols="12" md="6" class="mb-2">
              <b-form-group label="ประเภทหน่วยงาน">
                <b-form-radio-group
                  id="divisionType"
                  v-model="model.divisionType"
                  :options="divisionTypeOptions"
                  name="radio-divisionType"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <ValidationProvider name="ชื่อสำนักงาน/กอง" v-slot="{ errors }">
                <b-form-group label="ชื่อสำนักงาน/กอง" label-for="divisionName">
                  <b-form-input
                    id="divisionName"
                    v-model="model.divisionName"
                    placeholder="กรุณากรอก ชื่อสำนักงาน/กอง"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="3">
              <ValidationProvider name="เบอร์โทร" v-slot="{ errors }">
                <b-form-group label="เบอร์โทร" label-for="tel">
                  <b-form-input
                    id="tel"
                    v-model="model.tel"
                    placeholder="กรุณากรอก เบอร์โทร"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="3">
              <ValidationProvider
                rules="required"
                name="เบอร์มือถือ"
                v-slot="{ errors }"
              >
                <b-form-group label="เบอร์มือถือ" label-for="mobile">
                  <template v-slot:label>
                    เบอร์มือถือ <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="mobile"
                    v-model="model.mobile"
                    placeholder="กรุณากรอก เบอร์มือถือ"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="3">
              <ValidationProvider
                rules="required"
                name="อีเมล"
                v-slot="{ errors }"
              >
                <b-form-group label="อีเมล" label-for="email">
                  <template v-slot:label>
                    อีเมล <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="email"
                    v-model="model.email"
                    placeholder="กรุณากรอก อีเมล"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="3">
              <ValidationProvider name="ไลน์ไอดี" v-slot="{ errors }">
                <b-form-group label="ไลน์ไอดี" label-for="line">
                  <b-form-input
                    id="line"
                    v-model="model.line"
                    placeholder="กรุณากรอก ไลน์ไอดี"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <b-col cols="12" md="6">
              <b-form-group
                label="ลายเซ็นต์"
                label-for="file-input"
                class="mt-1"
              >
                <b-overlay rounded="sm">
                  <b-form-file
                    @change="onUploadFileChanged"
                    ref="file-input"
                    multiple
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  />
                </b-overlay>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-row
                v-for="file in this.attachFiles"
                :key="file.attachId"
                class="col-12 m-1 col-md-6"
              >
                <b-col md="10">
                  <a
                    :href="file.filePath"
                    :download="file.fileName"
                    target="_blank"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-arrow-down-circle"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="8 12 12 16 16 12" />
                      <line x1="12" y1="8" x2="12" y2="16" />
                    </svg>
                    {{ file.fileName }}
                  </a>
                </b-col>
                <b-col md="2" class="d-flex justify-content-center">
                  <a
                    href="javascript:void(0)"
                    class="text-danger"
                    @click="onAttachFileDelete(file.attachId)"
                  >
                    <feather-icon icon="Trash2Icon" size="24" />
                  </a>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" class="mb-5">
              <b-form-group label="สถานะการใชข้งาน">
                <b-form-radio-group
                  id="isActive"
                  v-model="model.isActive"
                  :options="activeOptions"
                  name="radio-is-active"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" class="d-flex justify-content-between">
              <b-button variant="secondary" @click="onCancelBtnClicked">
                ยกเลิก
              </b-button>
              <b-button variant="primary" @click="onSubmitBtnClicked">
                บันทึกข้อมูล
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </ValidationObserver>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormFile,
  BOverlay,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as mediateDirectorStore from "@/store/api/mediate-director/index.js";
import * as mediateDirectorGroupStore from "@/store/api/mediate-director/group.js";
import * as masterStore from "@/store/api/master/index.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import VueSelect from "vue-select";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormFile,
    BOverlay,
    ValidationObserver,
    ValidationProvider,
    VueSelect,
  },
  data() {
    return {
      model: {
        isActive: true,
        divisionType: "Internal",
      },
      groupSelect: null,
      groupOptions: [],
      officerSelect: null,
      officerOptions: [],
      directorPositionSelect: null,
      directorPositionOptions: [],
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
      divisionTypeOptions: [
        { text: "ภายใน", value: "Internal" },
        { text: "ภายนอก", value: "External" },
      ],
      attachFiles: [],
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      this.getDirectorGroup();
      this.getDirectorPosition();
      this.getOfficerList();
    } else {
      const id = this.$route.query.id;
      this.getById(id);
    }
  },
  methods: {
    getById(id) {
      const _this = this;

      mediateDirectorStore
        .getById(id)
        .then((response) => {
          _this.model = response.data.data.mediateDirectorData;
          _this.attachFiles = response.data.data.attachFiles;
          _this.getDirectorGroup();
          _this.getDirectorPosition();
          _this.getOfficerList();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getDirectorGroup() {
      const _this = this;
      mediateDirectorGroupStore.search({ isActive: true }).then((response) => {
        //console.log("getDirectorGroup response =>", response.data.data);
        _this.groupOptions = response.data.data;
        /// fill select data
        const groupSelect = _this.groupOptions.find((value) => {
          return value.id == _this.model.directorGroupId;
        });
        _this.groupSelect = groupSelect;
      });
    },
    getDirectorPosition() {
      const _this = this;
      masterStore.getMasterByType(16).then((response) => {
        //console.log("getMasterType = 16 response =>", response.data.data);
        _this.directorPositionOptions = response.data.data;
        /// fill select data
        const directorPositionSelect = _this.directorPositionOptions.find(
          (value) => {
            return value.masterId == _this.model.directorPositionId;
          }
        );
        _this.directorPositionSelect = directorPositionSelect;
      });
    },
    getOfficerList() {
      const _this = this;

      mediateDirectorStore
        .officerList()
        .then((response) => {
          _this.officerOptions = response.data.data;
          if (_this.$route.query.id !== null) {
            console.log("setOfficerSelect");
            const officerSelect = _this.officerOptions.find((value) => {
              return value.user_id == _this.model.userId;
            });

            if (officerSelect != null) {
              _this.officerSelect = officerSelect;
            } else {
              _this.officerSelect = null;
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.model.updateBy = userData.userId();
            _this.model.directorGroupId = _this.groupSelect.id;
            _this.model.directorPositionId =
              _this.directorPositionSelect.masterId;

            mediateDirectorStore
              .updateItem({
                mediateDirectorData: _this.model,
                attachFiles: _this.attachFiles,
              })
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: "MediateDirector",
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(
        this.$router.resolve({ name: "MediateDirector" }).href,
        "_self"
      );
    },
    selectOnInput() {
      this.$forceUpdate();
    },
    selectOnInputOfficer() {
      console.log("selectOnInputOfficer");
      

      const _this = this;
      /// ดึงข้อมูลของ officer ที่เลือกมาใส่ใน model
      if (_this.officerSelect != null) {
        mediateDirectorStore
          .officer(_this.officerSelect.user_id)
          .then((response) => {
            if (
              response.data != null &&
              response.data.success &&
              response.data.data != null
            ) {
              console.log("officer response =>", response.data.data);
              

              _this.$set(_this.model, 'identityId', response.data.data.personal_id);
              _this.$set(_this.model, 'prefix', response.data.data.title_name);
              _this.$set(_this.model, 'firstname', response.data.data.fname);
              _this.$set(_this.model, 'lastname', response.data.data.lname);
              _this.$set(_this.model, 'position', response.data.data.position);
              _this.$set(_this.model, 'divisionType', "Internal");
              _this.$set(_this.model, 'firstname', response.data.data.fname);
              _this.$set(_this.model, 'lastname', response.data.data.lname);
              _this.$set(_this.model, 'divisionName', response.data.data.divisioninfos != null && response.data.data.divisioninfos.length > 0 ? response.data.data.divisioninfos[0].divisionName: "");
              _this.$set(_this.model, 'tel', response.data.data.tel);
              _this.$set(_this.model, 'mobile', response.data.data.mobile_tel);
              _this.$set(_this.model, 'email', response.data.data.e_mail);
              //_this.$set(_this.model, 'line', response.data.data.line);
              _this.$set(_this.model, 'userId', response.data.data.user_id);
              
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else {
        console.log("officerSelect is null");
        _this.model.userId = null;
        //_this.$forceUpdate();
      }
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      //console.log("selectedFiles", selectedFiles);

      const _this = this;
      this.file3Overlay = true;

      selectedFiles.forEach(function(value, index) {
        console.log("value", value);
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected
        );
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            userId: userData.userId(),
            masterId: _this.selected,
            fileType: _this.selected,
          },
        ];
        storeFileUpload
          .uploadFile(data)
          .then(function(response) {
            // handle success
            console.log(response);
            response.data.data.forEach(function(value, index) {
              //console.log('emit upload', value)
              //this.$emit('handleSend', id)
              _this.emitAdditionalUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
            _this.file3Overlay = false;
          });
      };

      reader.readAsDataURL(fileObject);
    },
    emitAdditionalUploadFile(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
